/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    bool, func, number, object,
    arrayOf, shape, string,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Media from 'react-media';
import Button from '@material-ui/core/Button';
import Loading from '../../common/Loading';
import BackButton from '../../common/BackButton';
import AddressList from './AddressList';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import SortBy from './SortBy';
import configENV from '../../config';
import DesktopAddressBook from './DesktopAddressBook/DesktopAddressBook';

const { PERSIST_KEY } = configENV;
const sortByList = ['Sort By', 'Name', 'Relationship'];

class AddressBook extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            selectedIndex: 0,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { recipients, fetchAddressBook } = this.props;
        fetchAddressBook(recipients);
    };

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    handleAddNewAddressClicked = () => {
        const { handleAddNewRecipient } = this.props;
        handleAddNewRecipient();
    };

    handleSortByClicked = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleSortByClosed = () => {
        this.setState({ anchorEl: null });
    };

    handleSortByMenuItemClick = (event, index) => {
        const { handleChangeSortBy } = this.props;
        this.setState({
            selectedIndex: index,
            anchorEl: null,
        }, () => {
            handleChangeSortBy(sortByList[index]);
        });
    };

    render() {
        const {
            isFetchingModal, recipients, breakpoint,
            userProfile, featureFlags,
        } = this.props;
        const { anchorEl, selectedIndex } = this.state;
        const breakpointExpr = `(max-width: ${(breakpoint || CUSTOM_BREAKPOINTS.tabLandscape)}px)`;
        if (isFetchingModal) {
            return <Loading pageTitle="Address Book" />;
        }
        return (
            <>
                <Media query={breakpointExpr}>
                    {(matches) => (
                        matches ? (
                            <div>
                                <h1>
                                    <BackButton />
                                    Address Book
                                </h1>

                                <>
                                    <div className="row">
                                        <Button
                                            data-test="my-account-add-new-address"
                                            variant="contained"
                                            className="buttonHD margin-top"
                                            onClick={() => this.handleAddNewAddressClicked()}
                                        >
                                            Add New Address
                                        </Button>
                                    </div>
                                    <div className="display-none">
                                        <SortBy
                                            recipients={recipients}
                                            anchorEl={anchorEl}
                                            selectedIndex={selectedIndex}
                                            sortByList={sortByList}
                                            onSortByClicked={this.handleSortByClicked}
                                            onSortByClosed={this.handleSortByClosed}
                                            onSortByMenuItemClick={
                                                this.handleSortByMenuItemClick
                                            }
                                        />
                                    </div>

                                    <AddressList />
                                </>
                            </div>
                        ) : (
                            <>
                                <DesktopAddressBook userProfile={userProfile} featureFlags={featureFlags} />
                            </>
                        ))}
                </Media>
            </>
        );
    }
}

AddressBook.defaultProps = {
    fetchAddressBook: () => { },
    handleAddNewRecipient: () => { },
    handleChangeSortBy: () => { },
    recipients: [],
    userProfile: {},
    featureFlags: {},
    breakpoint: CUSTOM_BREAKPOINTS.tabLandscape,
};

AddressBook.propTypes = {
    isFetchingModal: bool.isRequired,
    recipients: arrayOf(
        shape({
            AddressBookEntryId: string,
            ContactId: number,
            NamePrefix: string,
            FirstName: string,
            MiddleInitial: string,
            LastName: string,
            NameSuffix: string,
            RelationShip: string,
            NickName: string,
            EmailAddress: string,
            LastUpdateDate: string,
            PhoneNumber: string,
            AlternatePhoneNumber: string,
            Fax: string,
            EmployerName: string,
            NumberOfAddresses: number,
            DateOfBirth: string,
            Addresses: arrayOf(
                shape({
                    AddressId: number,
                    AddressBookEntryId: string,
                    AddressType: string,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    City: string,
                    StateProvince: string,
                    PostalCode: string,
                    Country: string,
                    IsPartialMatch: bool,
                    IsUnknownAddress: bool,
                    Latitude_degrees: number,
                    Longitude_degrees: number,
                    IsBillingAddress: bool,
                    ContactId: number,
                }),
            ),
        }),
    ),
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }),
    featureFlags: object,
    fetchAddressBook: func,
    handleAddNewRecipient: func,
    handleChangeSortBy: func,
    breakpoint: number,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        toggleState: newState.toggleState,
        recipients: newState.recipients,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchAddressBook: (recipients) => dispatch(EventDispatcher.fetchAddressBook(recipients)),
    handleAddNewRecipient: () => dispatch(EventDispatcher.handleAddNewRecipient()),
    handleChangeSortBy: (sortBy) => dispatch(EventDispatcher.handleChangeSortBy(sortBy)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(AddressBook));
